// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"49861282","527":"ed2a5aaa","787":"d4aba7ab","791":"306220e5","792":"e227b79d"}[chunkId] + ".chunk.js";
};